import { createFileRoute } from '@tanstack/react-router';
import NewTemplatePage from '@/pages/(protected)/workspaces/[workspaceId]/templates/new'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/templates/new'
)({
  component: NewTemplatePage,
})
